<template lang="pug">
div.container-avatars
  div(v-for="(avatar,index) in avatarArray")
    el-badge(:hidden="!max || (index !== avatarArray.length - 1) || rest === 0" :value="`+${rest}`" class="item")
      el-tooltip(placement='top' :content="getValueFromObjectPath(label,avatar)")
        el-avatar(:style="avatarClass" :size="avatarSize") {{getFirstLetter(getValueFromObjectPath(label,avatar))}}
</template>

<script>

export default {
  props: {
    data: {
      type: Array,
      required: true
    },

    label: {
      type: String,
      required: true
    },

    max: {
      type: Number,
      default: 2
    },

    avatarClass: {
      type: Object,
      default: () => {
        return {
          'margin-right': '5px',
          'background-color': '#4E5C6B',
          'user-select': 'none'
        }
      }
    },

    avatarSize: {
      type: Number,
      default: 35
    },

    maxValueBadge: {
      type: Number,
      default: 99
    }
  },

  data () {
    return {
      avatarArray: [],
      rest: 0
    }
  },

  watch: {
    data: {
      async handler () {
        if (this.max) {
          this.avatarArray = this.data.slice(0, this.max)
          this.rest = this.data.length > this.max ? this.data.length - this.max : 0
          this.rest = this.rest > this.maxValueBadge ? this.maxValueBadge : this.rest
        } else {
          this.avatarArray = this.data
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    getFirstLetter (name) {
      return name ? name.charAt(0).toUpperCase() : '-'
    },

    getValueFromObjectPath (path, obj, separator = '.') {
      var properties = Array.isArray(path) ? path : path.split(separator)
      return properties.reduce((prev, curr) => prev && prev[curr], obj)
    }
  }
}
</script>
<style lang="scss" scoped>
.container-avatars {
  display: flex;
  flex-direction: row;
}

.item {
  margin-top: 10px;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AvatarList.vue